"use client";
import { Star } from "lucide-react";

export default function VerticalProgressBar({
  value,
  height = "100%",
  width = "4px",
  color = "#000000",
  backgroundColor = "#E5E7EB",
  completedTasks,
  totalTasks,
  onStarClick,
}) {
  const clampedValue = Math.min(100, Math.max(0, value));
  const allTasksCompleted = completedTasks === totalTasks;

  const handleStarClick = () => {
    if (allTasksCompleted) {
      onStarClick();
    } else {
      alert(`Complete all tasks to unlock your reward! (${completedTasks}/${totalTasks} completed)`);
    }
  };

  return (
    <div className="relative w-full h-full flex flex-col items-center">
      {/* Star at the top */}
      <div
        className={`mb-2 ${
          allTasksCompleted
            ? "cursor-pointer transform transition-transform duration-300 hover:scale-110"
            : "opacity-70 cursor-not-allowed"
        }`}
        onClick={handleStarClick}
        title={
          allTasksCompleted
            ? "Click to claim your reward!"
            : `Complete all tasks to unlock (${completedTasks}/${totalTasks})`
        }
      >
        <div className={`w-5 h-5 ${allTasksCompleted ? "text-yellow-400" : "text-black"}`}>
          {allTasksCompleted ? (
            <div className="relative">
              <div className="absolute -inset-1 bg-yellow-300/30 rounded-full blur-sm animate-pulse"></div>
              <Star className="fill-current animate-spin-slow" />
            </div>
          ) : (
            <Star className="fill-none" />
          )}
        </div>
      </div>

      {/* Progress bar container */}
      <div className="relative rounded-full overflow-hidden" style={{ height, width }}>
        {/* Background */}
        <div className="absolute inset-0" style={{ backgroundColor }}></div>

        {/* Progress fill */}
        <div
          className="absolute bottom-0 left-0 right-0 transition-all duration-300 ease-out"
          style={{
            height: `${clampedValue}%`,
            backgroundColor: color,
          }}
        ></div>
      </div>
    </div>
  );
}
